    const LatLng = require('./../latlng'),
    _ = require('lodash');

module.exports = function (shopLocatorService, $q, googleMapsApi, geolocation, breakpointsService, $state, $timeout, settingsService, $window) {
    return {
        restrict: 'E',
        scope: true,
        link(scope) {

        let google, map, mapCenter, selectedStore;
        let $map;
        let mapLoaded = false;
        const _breakpointsService = breakpointsService;
        const markers = {};

        scope.isSmallFormat = _breakpointsService.isInSmallFormat;

        scope.$on('window:resize', function () {
            scope.$apply(function () {
                scope.isSmallFormat = _breakpointsService.isSmallFormat();
            });
        });

        settingsService.getFrontendSetting('StorePages', 'StorePagesRedirect')
				.then((res) => {
                    const storePagesRedirectSettings = JSON.parse(res[0].Value);
                    if (storePagesRedirectSettings && storePagesRedirectSettings.EnableRedirect) {
                        const store = shopLocatorService.selectedStore;
                        const suburbInYextFormat = store.Suburb.trim().replace(/\s+/g, '-');
                        let storePathUrl = `${storePagesRedirectSettings.RedirectBaseUrl}/${store.State}-${suburbInYextFormat}-${store.StoreNo}`;
                        storePathUrl = storePathUrl.toLocaleLowerCase();
                        $window.location.assign(storePathUrl);
                    }
                });

        function resetMarkers() {
            _.forEach(markers, function (marker) {
                marker.setIcon('/Images/StoreLocator/icon-pin.png');
            });
        }

        function changeMarkerIcon(marker) {
            resetMarkers();
            marker.setIcon('/Images/StoreLocator/selected-pin-icon.png');

            scope.store = marker.storeInfo;
            mapCenter = marker.getPosition();
            map.setCenter(mapCenter);
        }

        scope.shopLocatorService = shopLocatorService;

        function createMarkerForStore() {
            let iconPath;
            if (selectedStore) {
                iconPath = '/Images/StoreLocator/selected-pin-icon.png';
            } else {
                iconPath = '/Images/StoreLocator/icon-pin.png';
            }

            const marker = new google.maps.Marker({
                position: new google.maps.LatLng(selectedStore.Latitude, selectedStore.Longitude),
                title: selectedStore.Name,
                map,
                icon: iconPath,
                storeInfo: selectedStore
            });
            markers[selectedStore.StoreNo] = marker;

            google.maps.event.addListener(marker, 'click', function () {
                $timeout(function () {
                  scope.shopLocatorService.setSelectedStore(marker.storeInfo);
                  changeMarkerIcon(marker);
                });
            });
        }

        function setStoreMarker(store) {
            const marker = markers[store.StoreNo];
            if (!marker) {
                createMarkerForStore(store);
            } else if (selectedStore) {
                changeMarkerIcon(marker);
            }
        }

        function goToSelectedStore() {
            const latlng = new google.maps.LatLng(selectedStore.Latitude, selectedStore.Longitude);
            map.setCenter(latlng);
            shopLocatorService.listSupermarkets(new LatLng(selectedStore.Latitude, selectedStore.Longitude)).then(_.partialRight(_.map, setStoreMarker));
        }

        scope.storeSelected = function (store) {
            selectedStore = store;
            if (map) {
                goToSelectedStore(store);
            }
        };

        function initialize() {

            const currentSelectedStore = shopLocatorService.selectedStore;
            $map = document.getElementById('map-canvas');
            const mapOptions = {
                zoom: 15,
                center: new google.maps.LatLng(currentSelectedStore.Latitude, currentSelectedStore.Longitude),
                panControl: false,
                streetViewControl: false,
                mapTypeControl: false,
                zoomControl: true,
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.SMALL,
                    position: google.maps.ControlPosition.RIGHT_BOTTOM
                }
            };
            map = new google.maps.Map($map, mapOptions);
            mapCenter = map.getCenter();

            shopLocatorService.listSupermarkets(new LatLng(currentSelectedStore.Latitude, currentSelectedStore.Longitude))
                .then(_.partialRight(_.map, setStoreMarker));

            // Sets the map center for whenever the map bounds change (drag/resize)
            google.maps.event.addListener(map, 'bounds_changed', function () {
                mapCenter = map.getCenter();
            });
        }

        function resizeCenterMap() {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(mapCenter);
            map.setZoom(map.getZoom());
        }

        function showMap() {
            initialize();
            resizeCenterMap();
        }

        function showDefaultLocationMap() {

            shopLocatorService.getDefaultLocation().then(function () {
                initialize(shopLocatorService.defaultCoords);
                resizeCenterMap();
            });
        }

        //re-draw the map on window resize
        scope.$on('window:resize', function () {
            if (map) {
                resizeCenterMap();
            }
        });

        scope.$on('storeLocator:detailsClose', resetMarkers);

        scope.$watch('shopLocatorService.selectedStore', function (store) {

            scope.showStoreDetails = store ? true : false;

              if (store && !mapLoaded) {
                googleMapsApi()
                    .then(function (googleApi) { google = googleApi; })
                    .then(showMap)
                    .catch(showDefaultLocationMap)
                    .then(function () {
                        mapLoaded = true;
                        if (shopLocatorService.selectedStore) {
                            scope.storeSelected(shopLocatorService.selectedStore);
                        }
                    });
              }
        });


        scope.$on('$destroy', function () {
          shopLocatorService.selectedStore = undefined;
        });
    },
    template: require('./shop-details-template.html').trim()
};
}
;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoplocator/storedetails/shop-details-directive.js
 **/